import { Injectable } from '@angular/core';
import { StorageProvider } from '../storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { Platform } from 'ionic-angular';
import { LoggerProvider, LoggerLevel, LoggerEvent } from '../logger/logger';
import { IterableProvider } from '../../providers/marketing/iterable';


@Injectable()
export class NotificationProvider {

  constructor(
    private storageProvider: StorageProvider,
    private platform: Platform,
    private iterableProvider: IterableProvider) { }

  /**
   * Subscribe to push notifications if enabled
   */
  async subscribe(customerId) {
    if (this.platform.is('cordova')) {
      const sendTransferNotifications = await this.storageProvider.get(`${customerId}-${StorageType.SendTransferNotifications}`);
      let shouldSubscribe = sendTransferNotifications === 'true';

      LoggerProvider.log(this, LoggerLevel.Info, LoggerEvent.Info, 'Should send transfer notifications', shouldSubscribe);

      if (sendTransferNotifications === null) {
        shouldSubscribe = true;
        await this.storageProvider.set(`${customerId}-${StorageType.SendTransferNotifications}`, 'true');

        LoggerProvider.log(this, LoggerLevel.Info, LoggerEvent.Info, `No setting for push notifications present. Defaulting to true for customerId ${customerId}`);
      }

      if (shouldSubscribe){
          this.iterableProvider.registerForPush();
      }
    }
  }

  async isPushEnabled(customerId){
    return this.storageProvider.get(`${customerId}-${StorageType.SendTransferNotifications}`);
  }

}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts